// extracted by mini-css-extract-plugin
export var page = "pageEnd-module--page--Z0E4p";
export var he = "pageEnd-module--he--DiH4Q";
export var hand = "pageEnd-module--hand--oSGo2";
export var icons = "pageEnd-module--icons--bZeVE";
export var text = "pageEnd-module--text--zZ6Pj";
export var buttons = "pageEnd-module--buttons--WOIV1";
export var btnRe = "pageEnd-module--btnRe--wbQdX";
export var btn = "pageEnd-module--btn--HbomG";
export var star = "pageEnd-module--star--bV1Fq";